import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAddRealtyModal } from '../context/AddRealtyModalContext';

type Props = {
  handleSaveRealty: () => void;
};

const AddRealtyModalFooter: FC<Props> = ({ handleSaveRealty }: Props) => {
  const { t } = useTranslate();
  const { data } = useAddRealtyModal();

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary "
          onClick={handleSaveRealty}
          disabled={!data?.name}
        >
          {t('SaveRealty')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default AddRealtyModalFooter;
